import React from 'react';
import Flagship from '../../core/flagship';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import IoProductAddModal from '../modals/IoProductAddModal';
import IoProductViewModal from '../modals/IoProductViewModal';
import IoProductEditModal from '../modals/IoProductEditModal';
import IoProductAssignModal from '../modals/IoProductAssignModal';
import {getFormattedValue, empty} from '../../utils/helpers';
import moment from 'moment';
import { Divider, Header, Loader, Card, Button, Icon, Label, Image} from 'semantic-ui-react';

class IoProductBox extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.getIoProducts = this.getIoProducts.bind(this);
        this.onAddNew = this.onAddNew.bind(this);
        this.cancelAddNew = this.cancelAddNew.bind(this);
        this.closeModals = this.closeModals.bind(this);
        this.renderIoProducts = this.renderIoProducts.bind(this);
        this.onIoProductAddModalChange = this.onIoProductAddModalChange.bind(this);
        this.onViewIoProduct = this.onViewIoProduct.bind(this);
        this.onEditIoProduct = this.onEditIoProduct.bind(this);
        this.onAddIoProduct = this.onAddIoProduct.bind(this);
        this.onUpdateIoProduct = this.onUpdateIoProduct.bind(this);
        this.onChangeAssignee = this.onChangeAssignee.bind(this);
        this.swapToEdit = this.swapToEdit.bind(this);
        this.swapToView = this.swapToView.bind(this);
        this.renderAddIoProductModal = this.renderAddIoProductModal.bind(this);
        this.renderAssignIoProductModal = this.renderAssignIoProductModal.bind(this);
        this.renderCriticalData = this.renderCriticalData.bind(this);
        this.onChangeProductStatus = this.onChangeProductStatus.bind(this);
        this.onChangeProductStatusCancel = this.onChangeProductStatusCancel.bind(this);
        this.onChangeProductStatusConfirm = this.onChangeProductStatusConfirm.bind(this);
        this.checkForIoStatusChanges = this.checkForIoStatusChanges.bind(this);
        this.maybeOpenIoProduct = this.maybeOpenIoProduct.bind(this);
    }

    getInitialState() {
        return {
            loading:true,
            ioProducts: [],
            newIoProductName: '',
            newIoProductService: null,
            newIoProductServiceNiceName: null,
            editPricingFields: [],
            addingIoProduct: false,
            viewingIoProduct: false,
            editingIoProduct: false,
            updatingPricing: false,
            editingAssignee: false,
            newIoProductData: [],
            editing: {},
            refreshing:false,
            savingIoProductChange: false
        }
    }

    componentDidMount() {
        this.getIoProducts();
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.viewingChild !== this.props.viewingChild) {
            this.maybeOpenIoProduct(nextProps);
        } else {
            if (nextProps !== this.props) {
                this.getIoProducts();
            }
        }
    }

    maybeOpenIoProduct(nextProps = false) {

        let propsToConsider = nextProps === false ? this.props : nextProps;
        let self = this;
        let viewingNow = false;

        this.state.ioProducts.map(function(item) {

            if (item.io_product_key === propsToConsider.viewingChild) {
                viewingNow = true;
                self.setState({
                    viewingIoProduct: item
                });
            }
        });
        if (viewingNow !== true ) {
            this.setState({
               viewingIoProduct: false
            });
        }
    }


    getIoProducts() {
        let self = this;
        Flagship.get(
            'io-products/' + this.props.recordId,
            {},
            function (response) {
                if (response.data.success === true) {
                    self.setState({
                        ioProducts: response.data.results,
                        loading:false,
                        refreshing:false
                    }, function() {
                        self.checkForIoStatusChanges();
                        // Open view of IO product if specified in component props
                        self.maybeOpenIoProduct();
                    });

                } else {

                    Flagship.error(
                        "Error getting IO products from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting IO products from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }


    onViewIoProduct(e, data, item) {
        this.setState({
            viewingIoProduct: item
        });
    }

    onEditIoProduct(e, data, item) {

        this.setState({
            editingIoProduct: item
        });
    }

    swapToEdit() {
        let item = this.state.viewingIoProduct;
        let self = this;

        this.setState({
            editingIoProduct: item

        }, function() {
            self.setState({
                viewingIoProduct: false,
            });
        });
    }

    swapToView() {
        let item = this.state.editingIoProduct;
        let self = this;

        this.setState({
            viewingIoProduct: item
        },function() {
            self.setState({
                editingIoProduct: false
            });
        });
    }

    onAddNew() {
        this.setState({
            addingIoProduct: true
        });
    }

    cancelAddNew() {
        this.setState({
           newIoProductService: null,
           newIoProductServiceNiceName: '',
           addingIoProduct: false
        });
    }


    closeModals() {
        this.setState({
            updatingPricing: false,
            viewingIoProduct: false,
            editingIoProduct: false,
            editingAssignee: false
        }, this.props.onCloseModals);
    }


    onIoProductAddModalChange(ioProductData) {
        this.setState({
            newIoProductData: ioProductData
        });
    }

    onAddIoProduct() {
        this.getIoProducts();
        this.setState({
            addingIoProduct: false
        });
        if (typeof this.props.onAddIoProduct === "function") {
            this.props.onAddIoProduct();
        }
    }

    onUpdateIoProduct() {
        let self = this;
        this.setState({
            editingIoProduct: false,
            editingAssignee: false,
            refreshing:true
        }, function() {
            self.getIoProducts();
        });
    }

    onChangeProductStatus(i) {
        this.setState({
            editingProduct: i
        });
    }

    onChangeAssignee(item) {
        this.setState({
            editingAssignee: item
        });
    }

    onChangeProductStatusCancel() {
        this.setState({
            editingProduct: false
        });
    }

    checkForIoStatusChanges() {
        let allIoProductsSubmitted = true;
        let allIoProductsLaunched = true;
        let allIoProductsComplete = true;
        let allIoProductsDead = true;
        let allIoProductsNew = true;
        let allIoProductsPaused = true;
        let someIoProductsNeedMaterials = false;
        let someIoProductsLaunched = false;
        let needsProducts = false;

        if (this.state.ioProducts.length === 0) {
            allIoProductsDead = false;
            allIoProductsSubmitted = false;
            allIoProductsLaunched = false;
            allIoProductsPaused = false;
            allIoProductsNew = false;
            needsProducts = true;
            allIoProductsComplete = false;
            allIoProductsDead = false;
            this.props.hasIoProducts(false);
        } else {

            this.props.hasIoProducts(true);
            this.state.ioProducts.map(function (item) {

                if (item.status !== "submitted" && item.status !== "trash") {
                    allIoProductsSubmitted = false;
                }
                if (item.status !== "launched" && item.status !== "trash") {
                    allIoProductsLaunched = false;
                }
                if (item.status !== "paused" && item.status !== "trash") {
                    allIoProductsPaused = false;
                }
                if (item.status !== "complete" && item.status !== "trash") {
                    allIoProductsComplete = false;
                }
                if (item.status !== "trash") {
                    allIoProductsDead = false;
                }
                if (item.status !== "publish") {
                    allIoProductsNew = false;
                }
                if (item.status === "needs_materials") {
                    someIoProductsNeedMaterials = true;
                }
                if (item.status === "launched") {
                    someIoProductsLaunched = true;
                }
            });
        }

        let newStatus = this.props.recordStatus;

        if (allIoProductsDead === true && newStatus !== "draft") {
            newStatus = 'trash';
        } else if (needsProducts === true) {
            newStatus = 'draft';
        } else if (allIoProductsSubmitted === true && allIoProductsDead === false) {
            newStatus = 'submitted';
        } else if (allIoProductsLaunched === true && allIoProductsDead === false) {
            newStatus = 'launched';
        } else if (allIoProductsComplete === true && allIoProductsDead === false) {
            newStatus = 'complete';
        } else if (allIoProductsPaused === true && allIoProductsDead === false) {
            newStatus = 'paused';
        } else if (someIoProductsNeedMaterials === true) {
            newStatus = 'needs_materials';
        } else if (someIoProductsLaunched === true) {
            newStatus = 'mixed';
        } else if (allIoProductsNew === true) {
            newStatus = 'publish';
        }

        let onStatusChange = this.props.onStatusChange;

        if ( newStatus !== this.props.recordStatus && this.props.recordStatus === "trash" ) {
            Flagship.changeRecordStatus(this.props.recordId, newStatus, function() {
                Flagship.notify("IO reactivated based on product status.");
                onStatusChange();
            });
        } else if ( newStatus !== this.props.recordStatus ) {
            Flagship.changeRecordStatus(this.props.recordId, newStatus, function() {
                Flagship.notify("Parent IO status updated automatically.");
                onStatusChange();
            });
        }
    }

    onChangeProductStatusConfirm(item, status) {

        let self = this;
        let id = item.id;

        this.setState({
            savingIoProductChange: true
        }, function() {
            Flagship.post("io-product/status/" + id,
                {
                    status
                }, function(response) {
                    if (response.data.success === true) {

                        let allProducts = [...self.state.ioProducts];

                        self.state.ioProducts.map(function(product, i) {
                           if (product.id === id) {
                               let productCopy = Object.assign({}, allProducts[i]);
                               productCopy.status = response.data.new_status;
                               allProducts[i] = productCopy;
                           }
                        });

                        self.setState({
                            ioProducts: allProducts
                        }, function() {
                            self.checkForIoStatusChanges();
                            Flagship.notify("Product status updated.");
                            if ( item.status !== response.data.new_status ) {
                                Flagship.event("update-io-product-status", {
                                    ioProductId: item.id,
                                    ioProductKey: item.io_product_key,
                                    ioProductName: item.io_product_name,
                                    oldStatus: item.status,
                                    newStatus: response.data.new_status,
                                }, self.props.recordId, self.props.userId);
                            }
                        });
                    } else {
                        Flagship.error("Failed to update product status.", self.props.recordId, self.props.userId);
                    }
                    self.setState({
                        savingIoProductChange: false,
                        editingProduct: false
                    });
                });
        });


    }

    renderCriticalData(item, i) {

        return (
            <div key={i}>

                {!empty( item.flights ) && item.flights.length > 0  ?
                    <div className="io-product-dates">
                        {!empty( item.flights ) && item.flights.length > 1 ?
                            <Label color="green">{item.flights.length + " Flights:" }</Label>: null }
                        {!empty( item.flights ) && item.flights.length === 1 ?
                            <Label color="green">1 Flight</Label> : null }
                        {item.flights.map(function(flight, i) {
                                return(
                                    <div key={i} className="product-box-flight">
                                        <Icon name="calendar"/>{getFormattedValue(moment(flight.startDate).unix(), 'date')} - {getFormattedValue(moment(flight.endDate).unix(), 'date')}
                                    </div>
                                );
                        })}
                    </div>
                : null }


            </div>
        );

    }

    renderIoProducts() {

        if ( typeof this.state.ioProducts === "object" && this.state.ioProducts.length === 0 ) {
            return (
                <div>No IO Products found.</div>
            );
        }

        let onEditIoProduct = this.onEditIoProduct;
        let renderCriticalData = this.renderCriticalData;
        let editingProduct = this.state.editingProduct;
        let onChangeProductStatus = this.onChangeProductStatus;
        let onChangeProductStatusCancel = this.onChangeProductStatusCancel;
        let onChangeProductStatusConfirm = this.onChangeProductStatusConfirm;
        let onChangeAssignee = this.onChangeAssignee;
        let savingIoProductChange = this.state.savingIoProductChange;
        let currentIoKey = this.props.recordKey;
        let userRole = this.props.userRole;


        return (
            <Card.Group>
                {this.state.ioProducts.map(function(item, i) {

                    if (editingProduct === i) {

                        let dropdownStatuses = [];

                        for (var status in Flagship.config.records.io.ioProductStatuses ) {
                            dropdownStatuses.push(
                                {
                                    key: status,
                                    text: Flagship.config.records.io.ioProductStatuses[status].label,
                                    color: Flagship.config.records.io.ioProductStatuses[status].color
                                }
                            );
                        }

                        if (savingIoProductChange === true) {
                            return (
                                <Card key={"line-item-" + i} className="single-line-item">
                                    <Card.Content>

                                        <Card.Header>
                                            <Header as="h4">{item.io_product_name}</Header>
                                        </Card.Header>
                                        <Card.Meta>Saving new status...</Card.Meta>
                                        <Card.Content extra>
                                            <Loader color="blue" className="flagship-loader" active inline='centered' />
                                        </Card.Content>
                                    </Card.Content>
                                </Card>
                            );
                        }

                        return (
                            <Card key={"line-item-" + i} className="single-line-item selecting-new-status">
                                <Card.Content>

                                    <Card.Header>
                                        <Header as="h4">{item.io_product_name}</Header>
                                    </Card.Header>
                                    <Card.Meta>Select a new status...</Card.Meta>
                                    <Card.Description>
                                    </Card.Description>
                                    <Card.Content extra>
                                        <div className="select-new-status">
                                        {dropdownStatuses.map(function(item_b) {
                                            return (
                                              <Label
                                                  className="change-io-product-status-label"
                                                  key={item_b.key}
                                                  color={item_b.color}
                                                  content={item_b.text}
                                                  onClick={() => {onChangeProductStatusConfirm(item, item_b.key)}}
                                              />
                                            );
                                        })}
                                        </div>
                                        <div className="cancel-button-container">
                                            <Button
                                                onClick={onChangeProductStatusCancel}
                                                basic size="small"
                                                color="grey"
                                                circular
                                                className="cancel-button"
                                                name="cancel"
                                                content="Cancel"
                                            />
                                        </div>
                                    </Card.Content>
                                </Card.Content>
                            </Card>
                        );
                    }

                   return (
                      <Card key={"line-item-" + i} className="single-line-item">
                          <Card.Content>
                              <Card.Header>
                              <Header as="h4">{item.io_product_name}</Header>
                              </Card.Header>
                              <Card.Description>
                                  {userRole === "dpm" || userRole === "social" || userRole === "admin" ?

                                      <div>

                                          <Label className="assignee-label" onClick={() => {onChangeAssignee(item)}}>

                                              {empty(item.assignee) ?

                                                  <div>
                                                  <Icon color="black"
                                                  circular
                                                  name="user"
                                                  />
                                                  Unassigned
                                                  <Icon name="caret down" fitted className="icon-down float-right"/>
                                                  </div>

                                                  :

                                                  <div>
                                                  <Image
                                                  src={Flagship.config.uploads + (!empty(item.photo) ? item.photo : 'someone.png')}
                                                  size='mini'
                                                  className="circular assignee-image"
                                                  />
                                                  {item.first_name + " " + item.last_name}
                                                  <Icon name="caret down" fitted className="icon-down float-right"/>
                                                  </div>
                                              }
                                          </Label>

                                          <Label
                                              className="change-io-product-status-label"
                                              color={Flagship.config.records.io.ioProductStatuses[item.status].color}
                                              onClick={() => {onChangeProductStatus(i)}}
                                          >
                                              {Flagship.config.records.io.ioProductStatuses[item.status].label + " "}
                                              <Icon name="caret down" fitted className="icon-down float-right"/>
                                          </Label>

                                      </div>
                                      :
                                      <div>

                                          <Label className="assignee-label">

                                          {empty(item.assignee) ?

                                              <div>
                                              <Icon color="black"
                                              circular
                                              name="user"
                                              />
                                              Unassigned
                                              </div>

                                              :

                                              <div>
                                              <Image
                                              src={Flagship.config.uploads + (!empty(item.photo) ? item.photo : 'someone.png')}
                                              size='mini'
                                              className="circular assignee-image"
                                              />
                                              {item.first_name + " " + item.last_name}
                                              </div>
                                          }
                                          </Label>

                                          <Label
                                              className="change-io-product-status-label"
                                              color={Flagship.config.records.io.ioProductStatuses[item.status].color}>
                                              {Flagship.config.records.io.ioProductStatuses[item.status].label}
                                          </Label>
                                      </div>
                                  }




                              </Card.Description>

                              <Card.Content extra>
                                  {renderCriticalData(item, i)}
                              </Card.Content>
                          </Card.Content>
                          <Card.Content extra>
                              <div className="ui two buttons line-item-actions">
                                  <Link to={"/io/view/" + currentIoKey + '/focus/' + item.io_product_key}><Button basic primary>View</Button></Link>
                                  <Button basic secondary onClick={(e, data) => {onEditIoProduct(e, data, item)}}>Edit</Button>
                              </div>
                          </Card.Content>


                      </Card>
                   ) ;
                })}
            </Card.Group>
        );
    }

    renderViewIoProductModal() {
        if (this.state.viewingIoProduct === false) {
            return null;
        } else {
            return (
                <IoProductViewModal
                    open={true}
                    cancelUpdate={this.closeModals.bind(this)}
                    ioProductId={!empty(this.state.viewingIoProduct.id) ? this.state.viewingIoProduct.id : false }
                    recordId={this.props.recordId}
                    ioProduct={this.state.viewingIoProduct}
                    swapToEdit={this.swapToEdit}
                    onChangeAssignee={this.onChangeAssignee}
                    onChangeProductStatus={this.onChangeProductStatus}
                    userRole={this.props.userRole}
                />
            );
        }
    }


    renderEditIoProductModal() {

        if (this.state.editingIoProduct === false) {
            return null;
        } else {
            return (
                <IoProductEditModal
                    open={true}
                    cancelUpdate={this.closeModals.bind(this)}
                    ioProductId={!empty(this.state.editingIoProduct.id) ? this.state.editingIoProduct.id : false }
                    recordId={this.props.recordId}
                    ioProduct={this.state.editingIoProduct}
                    swapToView={this.swapToView}
                    onChange={this.onIoProductEditModalChange}
                    onUpdateIoProduct={this.onUpdateIoProduct}
                />
            );
        }
    }


    renderAddIoProductModal() {
        if (this.state.addingIoProduct === false) {
            return null;
        } else {
            return (
                <IoProductAddModal
                    open={true}
                    cancelAddNew={this.cancelAddNew.bind(this)}
                    recordId={this.props.recordId}
                    onChange={this.onIoProductAddModalChange}
                    name={this.state.newIoProductName}
                    service={this.state.newIoProductService}
                    serviceNiceName={this.state.newIoProductServiceNiceName}
                    newIoProductService={this.state.newIoProductService}
                    onAddIoProduct={this.onAddIoProduct}
                />
            );
        }
    }

    renderAssignIoProductModal() {
        if (this.state.editingAssignee === false) {
            return null;
        } else {
            return (
                <IoProductAssignModal
                    open={true}
                    recordId={this.props.recordId}
                    data={this.state.editingAssignee}
                    onChange={this.onChangeAssignee}
                    cancelUpdate={this.closeModals.bind(this)}
                    onUpdateIoProduct={this.onUpdateIoProduct}
                    onChangeAssignee={this.props.onChangeAssignee}
                />
            );
        }
    }

    render() {
        return (
            <div className="line-item-box">
                <Divider hidden />
                <Header as="h3">IO Products</Header>
                {
                    this.state.loading === true ?
                        <Loader color="blue" className="flagship-loader" active inline='centered' />
                        :
                        <div>
                            {this.renderIoProducts()}
                            <br />
                            {this.props.recordStatus !== "launched" && this.props.recordStatus !== "trash" ?
                                <Button primary icon="plus" content="Add a Product" onClick={this.onAddNew}/>
                                :
                                <div className="gray-text">You cannot add any more products to this IO.</div>
                            }
                            <br />
                        </div>
                }
                {this.renderAddIoProductModal()}
                {this.renderViewIoProductModal()}
                {this.renderEditIoProductModal()}
                {this.renderAssignIoProductModal()}

            </div>
        );
    }
}

IoProductBox.propTypes = {
    actions: PropTypes.object,
    username: PropTypes.string,
    userId: PropTypes.number,
    userRole: PropTypes.string,
};

function mapStateToProps(state) {
  return {
      username: state.main.username,
      userId: state.main.userId,
      userRole: state.main.userRole
  };
}

export default connect(
  mapStateToProps
)(IoProductBox);





// WEBPACK FOOTER //
// ./src/components/records/IoProductBox.js